import { SVGProps } from "react";

export default function VideoIcon({ ...pros }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...pros}
    >
      <path
        d="M12.53 20.92H6.21C3.05 20.92 2 18.82 2 16.71V8.29C2 5.13 3.05 4.08 6.21 4.08H12.53C15.69 4.08 16.74 5.13 16.74 8.29V16.71C16.74 19.87 15.68 20.92 12.53 20.92Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5202 17.6L16.7402 15.65V9.34L19.5202 7.39C20.8802 6.44 22.0002 7.02 22.0002 8.69V16.31C22.0002 17.98 20.8802 18.56 19.5202 17.6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 11.5C12.3284 11.5 13 10.8284 13 10C13 9.17157 12.3284 8.5 11.5 8.5C10.6716 8.5 10 9.17157 10 10C10 10.8284 10.6716 11.5 11.5 11.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
